import AuthRequest from "../AuthRequest";
import AuthUrlMap from "../AuthUrlMap";
import isEmpty from "lodash/isEmpty";
import RequestInterceptor from "../RequestInterceptor";
import QueryStrings from "../QueryStrings";

const actions = {

    login: async ({commit}, credentials) => {
        let response = await AuthRequest.login({
            email: credentials.email,
            password: credentials.password
        });
        commit('UPDATE_TOKEN', response.data.data.token);
        return response;
    },

    me: async ({commit}) => {
        return await AuthRequest.me();
    },

    backgroundMe: async ({commit}) => {
        const meResponse = await AuthRequest.me();
        commit('UPDATE_USER', meResponse.data.data.user);
        return meResponse;
    },

    refreshToken: async ({commit}, refreshToken) => {
        commit('IS_REFRESHING_TOKEN', true);
        const response = await AuthRequest.refreshToken(refreshToken);
        commit('IS_REFRESHING_TOKEN', false);
        commit('UPDATE_TOKEN', response.data.data.token);
        return response;
    },

    register: async ({commit}, params) => {
        let response = await AuthRequest.register({
            firstName: params.firstName,
            lastName: params.lastName,
            username: params.username,
            email: params.email,
            password: params.password,
            passwordConfirmation: params.passwordConfirmation
        });

        commit('AUTHENTICATE_USER', {
            token: response.data.token,
            user: response.data.user
        });

        return response;
    },

    logout: async ({commit}) => {
        let response;
        try {
            commit('UPDATE_LOGOUT_LOADING', true);
            response = await AuthRequest.logout();
        } catch (e) {
            response = e.response;
        }
        commit('LOGOUT');
        commit('UPDATE_LOGOUT_LOADING', false);

        if (RequestInterceptor.unifiedLogin) {
            window.location = AuthUrlMap.AUTH_LOGOUT_URL;
        }
        return response;
    },

    forgotPassword: async ({}, credentials) => {
        return await AuthRequest.forgotPassword({
            email: credentials.email
        });
    },

    resetPassword: async ({commit}, params) => {
        let response = await AuthRequest.resetPassword({
            email: params.email,
            password: params.password,
            password_confirmation: params.passwordConfirmation,
            token: params.token
        });

        commit('AUTHENTICATE_USER', {
            token: response.data.token,
            user: response.data.user
        });

        return response;
    },

    redirectToLogin: async ({commit}, next) => {
        const urlParams = new URLSearchParams(window.location.search);

        if (RequestInterceptor.unifiedLogin) {
            if(urlParams.get(QueryStrings.CLIENT_GATEWAY)){
                let url = new URL(urlParams.get(QueryStrings.CLIENT_GATEWAY));

                if (!isEmpty(urlParams.get(QueryStrings.CLIENT_GATEWAY_UUID))) {
                    url.searchParams.append(QueryStrings.CLIENT_GATEWAY_UUID, urlParams.get(QueryStrings.CLIENT_GATEWAY_UUID));
                }

                if (!isEmpty(urlParams.get(QueryStrings.PLAYBOOK_UUID))) {
                    url.searchParams.append(QueryStrings.PLAYBOOK_UUID, urlParams.get(QueryStrings.PLAYBOOK_UUID));
                }

                if (!isEmpty(urlParams.get(QueryStrings.ORGANIZATION_UUID))) {
                    url.searchParams.append(QueryStrings.ORGANIZATION_UUID, urlParams.get(QueryStrings.ORGANIZATION_UUID));
                }

                return window.location.href = url;
            }

            if (urlParams.get(QueryStrings.BRANDED_LOGIN)) {
                let url = new URL(urlParams.get(QueryStrings.BRANDED_LOGIN));

                if (!isEmpty(urlParams.get(QueryStrings.LANDING_PAGE_UUID))) {
                    url.searchParams.append(QueryStrings.LANDING_PAGE_UUID, urlParams.get(QueryStrings.LANDING_PAGE_UUID));
                }

                if (!isEmpty(urlParams.get(QueryStrings.PROJECT_TYPE))) {
                    url.searchParams.append(QueryStrings.PROJECT_TYPE, urlParams.get(QueryStrings.PROJECT_TYPE));
                }

                if (!isEmpty(urlParams.get(QueryStrings.PROPERTY_SEARCH_ACTION))) {
                    url.searchParams.append(QueryStrings.PROPERTY_SEARCH_ACTION, urlParams.get(QueryStrings.PROPERTY_SEARCH_ACTION));
                }

                if (!isEmpty(urlParams.get(QueryStrings.PROPERTY_UUID))) {
                    url.searchParams.append(QueryStrings.PROPERTY_UUID, urlParams.get(QueryStrings.PROPERTY_UUID));
                }
                
                if (!isEmpty(urlParams.get(QueryStrings.PROPERTY_SEARCH_FILTER))) {
                    url.searchParams.append(QueryStrings.PROPERTY_SEARCH_FILTER, urlParams.get(QueryStrings.PROPERTY_SEARCH_FILTER));
                }

                if (!isEmpty(urlParams.get(QueryStrings.HOH_ADDRESS))) {
                    url.searchParams.append(QueryStrings.HOH_ADDRESS, urlParams.get(QueryStrings.HOH_ADDRESS));
                }

                return window.location.href = url;
            }

            return window.location = '/auth/login/redirect?redirectTo=' + encodeURIComponent(window.location.href);
        }
        if (typeof next !== "undefined"){
            return next({path: '/login'});
        }
        return RequestInterceptor.router.push('/login');
    },

    redirectToOnboarding: async ({commit}, next) => {
        if (RequestInterceptor.unifiedLogin) {
            let currentUrl = new URL(window.location);
            let urlParams = currentUrl.searchParams;
            let url = new URL(AuthUrlMap.ONBOARDING_URL);

            if (!isEmpty(urlParams.get(QueryStrings.SOURCE))) {
                url.searchParams.append(QueryStrings.SOURCE, urlParams.get(QueryStrings.SOURCE));
            }
            if (!isEmpty(urlParams.get(QueryStrings.CLIENT_GATEWAY_UUID))) {
                url.searchParams.append(QueryStrings.CLIENT_GATEWAY_UUID, urlParams.get(QueryStrings.CLIENT_GATEWAY_UUID));
            }
            if (!isEmpty(urlParams.get(QueryStrings.ORGANIZATION_UUID))) {
                url.searchParams.append(QueryStrings.ORGANIZATION_UUID, urlParams.get(QueryStrings.ORGANIZATION_UUID));
            }
            if (!isEmpty(urlParams.get(QueryStrings.PLAYBOOK_UUID))) {
                url.searchParams.append(QueryStrings.PLAYBOOK_UUID, urlParams.get(QueryStrings.PLAYBOOK_UUID));
            }

            if (!isEmpty(urlParams.get(QueryStrings.LANDING_PAGE_UUID))) {
                url.searchParams.append(QueryStrings.LANDING_PAGE_UUID, urlParams.get(QueryStrings.LANDING_PAGE_UUID));
            }
            return window.location = url;
        }

        return next();
    },
};

export default actions;
